import { httpClient } from "@/app/old/desktop/shared/services/";
const { VUE_APP_GIS_API_HOST } = process.env;
class API {
  constructor() {}
  async contour(req = {}) {
    return httpClient({
      url: `contours/dsm/${req.query ? `?${req.query}` : ""}`,
      baseURL: VUE_APP_GIS_API_HOST,
      method: "POST",
      data: req.body,
      headers: req.headers,
    });
  }
  async xyz(req = {}) {
    return httpClient({
      url: `xyz/dsm/${req.query ? `?${req.query}` : ""}`,
      baseURL: VUE_APP_GIS_API_HOST,
      method: "POST",
      data: req.body,
      headers: req.headers,
    });
  }
}
export const gisService = new API();
